import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { productCategoryEnum } from "@/modules/product";
import { AddProductPage } from "@/modules/product";
import { requireAuthAndPermission } from "@/utils";

const createProductSearchSchema = z.object({
  category: fallback(productCategoryEnum, "api").default("api")
});

export const Route = createFileRoute("/products/list/create")({
  validateSearch: zodValidator(createProductSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Create Product"
        description="Add a new product to the LAMPU Marketplace."
      />
      <AddProductPage />
    </>
  )
});
